module.exports = __webpack_public_path__ + "static/theme-editor-style-64dfa17c6a7127c52e76f53271adebd1.jpg";